import { ActiveStream } from "@blacknut/javascript-sdk/dist";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDeviceStreams, streamStopped } from "../redux/actions/Game";
import { State } from "../redux/reducers";
import { RouteNames, WithRouterProps } from "../utils/WithRouter";

const EMPTY: ActiveStream[] = [];
export const useStreamRecoverPage = (props: WithRouterProps<unknown>) => {
  const streams = useSelector((state: State) => state.globalState.streams.streams);
  const { navigate } = props;
  const audid = useSelector((state: State) => state.globalState.audid);
  const userStreams = audid ? getDeviceStreams(streams?.user || [], audid) : EMPTY;
  const dispatch = useDispatch();
  return {
    streams: userStreams,
    cancelAllStreams: React.useCallback(() => {
      userStreams.map(u => {
        streamStopped(u.streamId, "Canceled", undefined, false)(dispatch);
      });
      navigate({ name: RouteNames.HOME, clearHistory: true });
    }, [dispatch, navigate, userStreams]),
    recoverStream: React.useCallback(
      (u: ActiveStream) => {
        // cancel all others
        userStreams.map(u2 => {
          if (u2.streamId !== u.streamId) {
            streamStopped(u2.streamId, "Canceled", undefined, true)(dispatch);
          }
        });

        // go to play page
        navigate({
          name: RouteNames.PLAY,
          gameId: u.game.id,
          origin: "recover",
          mode: "recover",
          streamId: u.streamId,
          clearHistory: true,
        });
      },
      [dispatch, navigate, userStreams],
    ),
  };
};
